import { render, staticRenderFns } from "./rubric_ai.vue?vue&type=template&id=838b107a&scoped=true&"
import script from "./rubric_ai.vue?vue&type=script&lang=js&"
export * from "./rubric_ai.vue?vue&type=script&lang=js&"
import style0 from "./rubric_ai.vue?vue&type=style&index=0&id=838b107a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838b107a",
  null
  
)

export default component.exports